import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/like.png'
import _imports_1 from '../assets/img/zan.png'
import _imports_2 from '../assets/img/input_top.png'
import _imports_3 from '../assets/img/input_bottom.png'
import _imports_4 from '../assets/img/input_btn.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-2830699a")

_pushScopeId("data-v-2830699a")
const _hoisted_1 = { class: "propose" }
const _hoisted_2 = { class: "xf" }
const _hoisted_3 = { class: "like" }
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  class: "hover",
  alt: ""
}
const _hoisted_5 = {
  key: 2,
  src: _imports_0,
  alt: ""
}
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { class: "input" }
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1)
const _hoisted_10 = { class: "num" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Xiaofeng = _resolveComponent("Xiaofeng")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Xiaofeng)
    ]),
    (_ctx.list)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: ["content", _ctx.focus ? 'propose-content-focus' : '']
        }, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, i) => {
            return (_openBlock(), _createBlock("div", {
              class: "layer",
              style: `animation: scrollDanmu ${ _ctx.dmLayerRandom[i][0] }s 0s linear infinite; margin-left: -${ _ctx.dmLayerRandom[i][1] }vw;`,
              key: 'layer_' + i
            }, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(item, (info, j) => {
                return (_openBlock(), _createBlock("div", {
                  class: "item",
                  style: `background-color: rgba(54, ${ info.color[0] }, 255, ${ info.color[1] });`,
                  key: 'item_' + j
                }, [
                  _createVNode("div", _hoisted_3, [
                    (info.isLike)
                      ? (_openBlock(), _createBlock("img", _hoisted_4))
                      : _createCommentVNode("", true),
                    (!info.isLike)
                      ? (_openBlock(), _createBlock("img", {
                          key: 1,
                          src: _imports_1,
                          alt: "",
                          onClick: ($event: any) => (_ctx.handleLike(info.id, [i, j]))
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    (info.isLike)
                      ? (_openBlock(), _createBlock("img", _hoisted_5))
                      : _createCommentVNode("", true),
                    (info.like)
                      ? (_openBlock(), _createBlock("span", _hoisted_6, "+" + _toDisplayString(info.like), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createTextVNode(" " + _toDisplayString(info.info), 1)
                ], 4))
              }), 128))
            ], 4))
          }), 128))
        ], 2))
      : _createCommentVNode("", true),
    _createVNode("div", {
      class: ["submit", _ctx.focus ? 'propose-focus' : '']
    }, [
      _createVNode("div", _hoisted_7, [
        _hoisted_8,
        _withDirectives(_createVNode("textarea", {
          placeholder: "我要建议...",
          maxlength: 50,
          ref: "input",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.propose = $event)),
          onFocus: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleFocus && _ctx.handleFocus(...args))),
          onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.focus = false))
        }, null, 544), [
          [_vModelText, _ctx.propose]
        ]),
        _hoisted_9,
        _createVNode("div", _hoisted_10, _toDisplayString(_ctx.propose.length) + "/50", 1)
      ]),
      _createVNode("img", {
        src: _imports_4,
        class: "btn",
        alt: "",
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
      })
    ], 2)
  ]))
})